// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FlagOutlinedSvg from "@fishx/icons-svg/es/asn/FlagOutlined";
import FishxIcon from '../components/FishxIcon';

var FlagOutlined = function FlagOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: FlagOutlinedSvg
  }));
};

FlagOutlined.displayName = 'FlagOutlined';
export default React.forwardRef(FlagOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/FlagOutlined.js
// module id = 2792
// module chunks = 0